import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate";

import { required, email } from "vee-validate/dist/rules";

// Rules
extend("required", {
  ...required,
  message: "This field is required"
});

extend("email", {
  ...email,
  message: "Please enter a valid email address"
});


Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
